/**
 * CopilotRecognition.jsx — M10 (Phase 4 Engagement)
 * =================================================
 * Reconnaissance FACTUELLE et VARIABLE par le copilote IA (Coach/Pilote/Confident).
 * Ton expert, jamais "Bien joué !". S'affiche en tête du Coaching IA si un fait
 * marquant existe (alertes traitées, mandats réactivés, régularité…).
 */
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import api from '../../lib/api';
import { Sparkles } from 'lucide-react';

export default function CopilotRecognition() {
    const [rec, setRec] = useState(null);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const r = await api.get('/engagement/copilot/recognition');
                if (alive) setRec(r.data.recognition);
            } catch (e) {
                // silencieux
            }
        })();
        return () => { alive = false; };
    }, []);

    if (!rec) return null;

    return (
        <motion.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex items-start gap-3 rounded-2xl border border-[#A855F7]/25 bg-[#681793]/12 p-3.5"
            data-testid="copilot-recognition"
        >
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#681793] to-[#A855F7] flex items-center justify-center shrink-0">
                <Sparkles className="w-4 h-4 text-white" />
            </div>
            <div className="min-w-0">
                <span className="text-[10px] font-bold uppercase tracking-wider text-[#C8A2FF]">
                    Votre {rec.role_label} a remarqué
                </span>
                <p className="text-sm text-white/90 leading-snug mt-0.5" data-testid="copilot-recognition-message">
                    {rec.message}
                </p>
            </div>
        </motion.div>
    );
}
